(function(){

  'use strict';

    // **********************************
    //  Data that this directive needs
    // ----------------------------------
    // 
    //

  function pxCreateGoProfile(
    $http, $filter, toastr
    ) {
    return {
      restrict: 'EA',
      scope: {
        context: '=context',
        tenant: '=tenant',
        printer: '=printer',
        meta: '=meta',
        callback: '&callback'
      },
      templateUrl: 'app/components/onDeviceConfigProperties/createGoProfile/createGoProfile.template.html',
      link: function(scope) {

        scope.goProfile = {
          name: '',
          username: '',
          secret: '',
          description: '',
          printers: [],
          useOnPrinter: scope.printer ? true : false
        };

        scope.saveGoProfile = function () {
          var goProfileObject = angular.copy(scope.goProfile);
          goProfileObject.secret = btoa(goProfileObject.secret);
          if (scope.printer && goProfileObject.useOnPrinter) {
            goProfileObject.printers.push(scope.printer.info._links.self.href);
          }
          delete goProfileObject.useOnPrinter;
          var url = scope.tenant.info._links['px:printerCredentials'].href;
          $http.post(url, goProfileObject).then(function(response) {
            toastr.success($filter('translate')('ChangesSaved'))
          }).catch(function(error) {
            toastr.error($filter('translate')('ERROR'))
          });
          scope.callback();
        }
      }
    };
  }

  pxCreateGoProfile.$inject = [
    '$http', '$filter', 'toastr'
  ];

  angular
    .module('printix-admin')
    .directive('pxCreateGoProfile', pxCreateGoProfile);

})();
